import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '../utils/constant';
import { useContext, useMemo } from 'react';
import { SessionInterceptor } from '@reconvert/react-ui-component';
import { useAppSelector } from '../app/hooks';
import { Redirect } from '@shopify/app-bridge/actions';
import { RootState } from '../app/store';
import { selectShopInfoState } from '../ReviewProviderWrapper';
import { createApp } from '@shopify/app-bridge';

const AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

SessionInterceptor.addInterceptors(AxiosInstance);

const axiosRequest =
  (app: any, shopify: any, token: string) =>
  async (config = {}, isPrivate = true) => {
    let axConfig = { ...config } as AxiosRequestConfig;
    let headers = {};

    if (token && isPrivate) {
      headers = {
        Authorization: `Bearer ${token}`,
        'x-admin': 1,
      };
    } else if (shopify) {
      const shopifyToken = await shopify.idToken();

      headers = {
        Authorization: `Bearer ${shopifyToken}`,
      };
    }

    axConfig.headers = { ...(axConfig?.headers || {}), ...headers };
    try {
      const response = await AxiosInstance.request(axConfig);

      checkHeadersForReauthorization(app, response.headers);

      return response;
    } catch (e: any) {
      if (e?.response?.headers) {
        checkHeadersForReauthorization(app, e.response.headers);
      }

      throw e;
    }
  };

const checkHeadersForReauthorization = (app: any, headers: any) => {
  if (headers.get('X-Shopify-API-Request-Failure-Reauthorize') === '1') {
    const authUrlHeader =
      headers.get('X-Shopify-API-Request-Failure-Reauthorize-Url') ||
      `/api/auth`;

    app.dispatch(
      Redirect.toRemote({
        url: decodeURIComponent(
          authUrlHeader.startsWith('/')
            ? `https://${window.location.host}${authUrlHeader}`
            : authUrlHeader
        ),
      })
    );
  }
};

export const useFetch = (app: any, shopify: any, token: string) => {

  const memoizedFetch = useMemo(
    () => axiosRequest(app, shopify, token),
    [app, shopify, token]
  );

  return memoizedFetch;
};

